import React from 'react'
import moment from 'moment'
import requestAProposalImg from 'src/assets/images/request-a-proposal-img.png'
import { QuizQuestionWrapper } from '../QuizQuestionWrapper'
import { useRequestAProposal } from './RequestAProposal.hook'

import './style.scss'

export const RequestAProposal = () => {
  const { data, nextDisabled, handleNext, handleBack, recordResponse } = useRequestAProposal()

  return (
    <>
      <QuizQuestionWrapper
        titleStep="Getting Started"
        backAction={{
          onAction: handleBack,
        }}
        nextAction={{
          onAction: handleNext,
          disabled: nextDisabled,
        }}
        className="request-a-proposal"
      >
        <div className="request-a-proposal-wrapper">
          <div className="left-part">
            <img src={recordResponse?.imageUrl || requestAProposalImg} alt="request a proposal img" />
          </div>
          <div className="right-part">
            <div className="request-content">
              {recordResponse?.totalWeddings ? (
                <div className="weddings-done-wrapper">
                  <div className="weddings-done">
                    <span>
                      {`We've done ${recordResponse?.totalWeddings} wedding${
                        recordResponse?.totalWeddings === 1 ? '' : 's'
                      } at ${recordResponse.venueName}`}
                    </span>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <h2>We’re available for your wedding!</h2>
              <p>
                We would love to see you on {moment(data.weddingDate?.weddingDate).format('MMMM DD, YYYY')}{' '}
                {recordResponse?.venueName ? 'at' : 'in'}{' '}
                {recordResponse?.venueName || `${(data.location || [])[0]?.city}, ${(data.location || [])[0]?.state}`}.
              </p>
              <h3>Ready to get started?</h3>
              <p className="help-text">
                Choose a budget and color palette to start reviewing options for your wedding flowers. Our team is
                standing by to help!
              </p>
              <div className="action-box-wrapper mt-30px pb-70px">
                <button disabled={nextDisabled} className="button white-space-wrap" onClick={handleNext}>
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
